import React from 'react';
import { translate } from '../Services/translation';
import MiniCartProduct from './MiniCartProduct'

const MiniCart = ({
    quantity,
    checkoutUrl,
    showInfo,
    toggle,
    update,
    orderRows,
    deliveryCost,
    grandTotal,
    hidePrices
}) => (
        <div className="cart cart--mini">
            <button className="cart__link--block" onClick={() => toggle()}>
                <i className="cart__icon"></i>
                <span className="cart__title">{translate('minicart.checkout')}</span>
                {quantity > 0 && <span className="cart__quantity">{quantity}</span>}
            </button>
            <div
                className={`cart__dimmer${!showInfo ? ' cart__dimmer--hidden' : ''}`}
                onClick={() => toggle(false)}
            >
            </div>
            <div className={`cart__info${!showInfo ? ' cart__info--hidden' : ''}`}>
                <span className="cart__close-button" onClick={() => toggle()}></span>
                {orderRows.length ? (
                    <div>
                        <h2>{translate('minicart.heading')}</h2>
                        {orderRows.map(orderRow => {
                            const { rowSystemId, quantity } = orderRow;
                            return (
                                <MiniCartProduct
                                    key={rowSystemId}
                                    product={orderRow}
                                    onCartItemIncrement={() => update(rowSystemId, quantity + 1)}
                                    onCartItemDecrement={() => update(rowSystemId, quantity - 1)}
                                    onCartItemRemove={() => update(rowSystemId, 0)}
                                />
                            );
                        })}
                        {!hidePrices?(<div className="cart__summary">
                            <div className="cart__summary__info-row">
                                <div className="cart__split-row">
                                    <span>{translate('minicart.deliverycost')}</span>
                                    <span>{deliveryCost}</span>
                                </div>
                            </div>
                            <div className="cart__summary__info-row">
                                <div className="cart__total-heading">{translate('minicart.grandtotal')}:</div>
                                <div className="cart__split-row">
                                    <span>{translate('minicart.taxesincluded')}</span>
                                    <span className="cart__split-row__total">{grandTotal}</span>
                                </div>
                            </div>
                        </div>):null}
                        <a href={checkoutUrl} className="cart__checkout-button">{translate('minicart.checkout')}</a>
                    </div>
                ) : (
                        <h2>{translate('minicart.emptyheading')}</h2>
                    )}
            </div>
        </div>
    )

export default MiniCart;